/* přidat pod window objekt, který se načítá na každé stránce a umí:

 Example volání v konzoli:
  - CNC.recombeeAdvertAPI.getData().then((response) => console.log(response))

*/

import * as RecombeeJSAPIClient from 'recombee-js-api-client';
import { RecombeeClient as client } from '@components';
import * as recombeeConfig from '@utils/recombee';
import { CNCRecombee } from '@customTypes/recombee/CNCRecombee';
import { GTMTrack } from '@utils/dataLayer';
import recombeeScenarios from './advertisementSupportScenarios.json';
import * as Sentry from '@sentry/browser';

export const recombeeAdvertAPI = () => {
  if (!window.CNC || !window.CNC.recombee) {
    return;
  }

  // Zvolit scénář dle domény a klíče
  const actualHost = window.location.host;
  const scenarios: { [key: string]: string } = recombeeScenarios;
  const scenarioKey = Object.keys(scenarios).find((key) => actualHost.includes(key)) as string;
  if (!scenarioKey) {
    Sentry.captureMessage('recombeeAdvertAPI: Missing scenarioKey');
    return;
  }
  const scenario = scenarios[scenarioKey];
  recombeeConfig.request.scenario = scenario;

  // Načíst hodnoty z inicializace recombee
  const CNCRecombeeWindowConfig = window.CNC.recombee;
  const { userId, articleId: sourceArticleId }: CNCRecombee.General = CNCRecombeeWindowConfig;
  const articlesCount = 1;

  // Přidat funkce do globálního scope
  if (sourceArticleId)
    window.CNC.recombeeAdvertAPI = {
      // Metoda pro načtení dat
      getData: async () => {
        return client.send(
          new RecombeeJSAPIClient.RecommendItemsToItem(
            sourceArticleId,
            userId,
            articlesCount,
            recombeeConfig.request
          )
        );
      },

      // Metoda pro odeslání dat do GTM
      handleClick: (article: CNCRecombee.Article) => {
        const {
          title,
          url,
          categories,
          updated_at: updatedAt,
          author,
          is_premium: premium,
        } = article.values;

        // Odeslat data do GTM
        GTMTrack('list_itemClick', {
          item: {
            elementId: article.id,
            type: 'Article',
            layout: 'string',
            list: 'slideUpRecommended',
            listLayout: 'slideUpRecommended',
            position: 1,
            systemId: actualHost,
            id: article.id,
            versionId: updatedAt || '', // Timestamp update článku. (Unix číslo)
            title,
            category: categories,
            author: [author],
            premium,
            source: 'slideUpRecommended',
            url,
          },
          _clear: true,
        });
      },
    };
};
